import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";
import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";

import { LargeText, SmallTitle } from "../../ui-components/texts";

import { useTranslate } from "../../contexts/translate";

// images
import imageCover from "../../media/images/portfolio-images/cips/image-cover.png";
import { ContainerBlock } from "../../ui-components/columns/components";
import { TitleWithScrollXImagesSection } from "./components-design";
import { FullWidthVideo } from "../../ui-components/videos";

const Cips = ({ setNextPageHref = () => {}, setNextPageName = () => {} }) => {
	useEffect(() => {
		setNextPageHref("/projects/costumi-di-sicilia");
		setNextPageName("Costumi Di Sicilia");
		document.title = "CIPS - Cutting Edge Digital Creative Studio";
	}, []);

	const { translations } = useTranslate();
	const peoples = [
		{
			fullname: "Giuseppe Bussolari",
			image: require("../../media/team-images/Giuseppe Bussolari.jpg").default,
			role: translations === null ? "" : translations.about.peoples[8].role,
			description:
				translations === null ? "" : translations.about.peoples[8].description,
		},
		{
			fullname: "Andrea Carollo",
			image: require("../../media/team-images/Andrea Carollo.jpg").default,
			role: translations === null ? "" : translations.about.peoples[4].role,
			//description:
				//translations === null ? "" : translations.about.peoples[4].description,
			description: "",
		},
		{
			fullname: "Michela Giuffrida",
			image: require("../../media/team-images/Michela Giuffrida.jpg").default,
			role: translations === null ? "" : translations.about.peoples[2].role,
			//description:
				//translations === null ? "" : translations.about.peoples[2].description,
			description: "",
		}
	];

	return (
		<div className="project-page project-page-cips">
			<CoverPorfolio
				background="#5999ff"
				className="theme-dark"
				title="CIPS"
				white={true}
				text={translations && translations.cips.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"CIPS"}
				services={["Brand Strategy", "Brand Identity", "Website"]}
				timeframe={"2022 - Today"}
				introduction={
					<>
						<LargeText>
							{translations && translations.cips.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.cips.descriptions[1]}
						</LargeText>
					</>
				}
			/>

			<section
				className="theme-light small-padding"
				style={{ background: "#fff" }}
			>
				<ContainerBlock className="fluid" style={{ padding: "0 50px" }}>
					<SmallTitle className="mb-4">
						{translations && translations.cips.sections[0].title}
					</SmallTitle>
					<LargeText>
						{translations && translations.cips.sections[0].text1}
					</LargeText>
					<LargeText>
						{translations && translations.cips.sections[0].text2}
					</LargeText>
				</ContainerBlock>
			</section>

			{/* video */}
			<section
				className="theme-light mid-padding"
				style={{ background: "#fff" }}
			>
				<ContainerBlock className="fluid" style={{ padding: "0 50px" }}>
					<FullWidthVideo isImage={false} previewImage={"#0e15f5"} srcVideo={require('../../media/images/portfolio-images/cips/video.mp4').default} />
				</ContainerBlock>
			</section>

			<TitleWithScrollXImagesSection
				className="theme-dark"
				color={"#5999ff"}
				title={translations && translations.cips.sections[1].title}
				text={translations && translations.cips.sections[1].text}
				items={[ { src: require('../../media/images/portfolio-images/cips/gallery-1/1.png').default }, { src: require('../../media/images/portfolio-images/cips/gallery-1/2.png').default }, { src: require('../../media/images/portfolio-images/cips/gallery-1/3.png').default } ]}
			/>

			<section
				className="theme-light mid-padding"
				style={{ background: "#fff" }}
			>
				<ContainerBlock className="fluid" style={{ padding: "0 50px" }}>
					<img className="w-100" src={require('../../media/images/portfolio-images/cips/image-1.png').default} alt="CIPS Banner" />
				</ContainerBlock>
			</section>


			<TitleWithScrollXImagesSection
				color={"#5999ff"}
				className="theme-dark"
				title={translations && translations.cips.sections[2].title}
				text={translations && translations.cips.sections[2].text}
				items={[ { src: require('../../media/images/portfolio-images/cips/gallery-2/1.png').default }, { src: require('../../media/images/portfolio-images/cips/gallery-2/2.png').default }, { src: require('../../media/images/portfolio-images/cips/gallery-2/3.png').default } ]}
			/>

			<PeopleOfMasamune peoples={peoples} />
				<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Cips.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Cips;
